<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 25 25">
        <g
            id="Layer_2"
            data-name="Layer 2">
            <g
                id="Layer_1-2"
                data-name="Layer 1">
                <g
                    id="Group_18653"
                    data-name="Group 18653">
                    <g
                        id="Group_18648-2"
                        data-name="Group 18648-2">
                        <rect
                            id="Rectangle_27249-7"
                            data-name="Rectangle 27249-7"
                            class="border-rect"
                            x="0.5"
                            y="0.5"
                            width="24"
                            height="24"
                            rx="4.57" />
                        <line
                            id="Line_37-7"
                            data-name="Line 37-7"
                            class="h-separator"
                            x1="0.5"
                            y1="6.84"
                            x2="24.06"
                            y2="6.84" />
                        <path
                            id="Path_5145-7"
                            data-name="Path 5145-7"
                            class="status-light"
                            d="M6.12,3.87a1,1,0,1,1-1-1,1,1,0,0,1,1,1Z" />
                        <path
                            id="Path_5146-7"
                            data-name="Path 5146-7"
                            class="status-light"
                            d="M10,3.87a1,1,0,1,1-1-1,1,1,0,0,1,1,1Z" />
                        <path
                            id="Path_5147-7"
                            data-name="Path 5147-7"
                            class="status-light"
                            d="M13.8,3.87a1,1,0,1,1-1-1,1,1,0,0,1,1,1Z" />
                    </g>
                    <g
                        id="Group_18650-2"
                        data-name="Group 18650-2">
                        <path
                            id="Path_5255-2"
                            data-name="Path 5255-2"
                            class="sliders"
                            d="M13.41,19v2.29H11.49V19" />
                        <path
                            id="Path_5256-2"
                            data-name="Path 5256-2"
                            class="sliders"
                            d="M6.55,13.93V9.38H8.47v4.55" />
                        <path
                            id="Path_5257-2"
                            data-name="Path 5257-2"
                            class="sliders"
                            d="M8.47,16.68v4.56H6.55V16.68" />
                        <path
                            id="Path_5258-2"
                            data-name="Path 5258-2"
                            class="sliders"
                            d="M11.49,16.2V9.37h1.92V16.2" />
                        <circle
                            id="Ellipse_93-2"
                            data-name="Ellipse 93-2"
                            class="knobs"
                            cx="12.5"
                            cy="17.55"
                            r="1.69" />
                        <path
                            id="Path_5259-2"
                            data-name="Path 5259-2"
                            class="sliders"
                            d="M16.43,11.39v-2h1.92v2" />
                        <path
                            id="Path_5260-2"
                            data-name="Path 5260-2"
                            class="sliders"
                            d="M18.35,14.14v7.1H16.43v-7.1" />
                        <circle
                            id="Ellipse_94-2"
                            data-name="Ellipse 94-2"
                            class="knobs"
                            cx="7.56"
                            cy="15.29"
                            r="1.69" />
                        <circle
                            id="Ellipse_95-2"
                            data-name="Ellipse 95-2"
                            class="knobs"
                            cx="17.44"
                            cy="12.75"
                            r="1.69" />
                    </g>
                </g>
            </g>
        </g>
    </svg>
</template>

<style lang="scss" scoped>
    .border-rect,
    .status-light {
        fill: #ffffff;
    }
    .border-rect,
    .status-light,
    .h-separator {
        stroke: var(--bs-primary-700);
    }
    .border-rect,
    .status-light,
    .h-separator,
    .sliders,
    .knobs {
        stroke-linecap: round;
        stroke-linejoin: round;
    }
    .h-separator {
        fill: none;
    }
    .sliders,
    .knobs {
        fill: var(--bs-primary-200);
    }
    .sliders {
        stroke: var(--bs-primary-600);
    }
    .knobs {
        stroke: var(--bs-primary-500);
    }
</style>
